export default ({ request }) => ({
  shipmentExpenseListApi(data = {}) {
    return request({
      url: '/factory/shipment/expense/list',
      method: 'post',
      data,
    })
  },
  shipmentExpenseDetailApi(data = {}) {
    return request({
      url: '/factory/shipment/expense/detail',
      method: 'post',
      data,
    })
  },
  shipmentExpenseSaveApi(data = {}) {
    return request({
      url: '/factory/shipment/expense/save',
      method: 'post',
      data,
    })
  },
  shipmentExpenseDelApi(data = {}) {
    return request({
      url: '/factory/shipment/expense/del',
      method: 'post',
      data,
    })
  },
  shipmentExpenseStatementOptionalApi(data = {}) {
    return request({
      url: '/factory/shipment/expense/statementOptional',
      method: 'post',
      data,
    })
  },
  shipmentExpenseSelectReceiptApi(data = {}) {
    return request({
      url: '/factory/shipment/expense/selectReceipt',
      method: 'post',
      data,
    })
  },
  shipmentExpenseUploadReceiptApi(data = {}) {
    return request({
      url: '/factory/shipment/expense/uploadReceipt',
      method: 'post',
      data,
    })
  },
  shipmentExpenseSubmitOaApplyApi(data = {}) {
    return request({
      url: '/oa/shipment/expense/apply',
      method: 'post',
      data,
    })
  },
})
